module.exports = __webpack_public_path__ + "static/img/collect.775f8bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/collect.png
// module id = ayMy
// module chunks = 36